import { Pie, Line } from "@ant-design/plots";

export default function Charts({ transactions }) {
  const income = transactions
    .filter((t) => t.type.toLowerCase() === "income")
    .reduce((sum, t) => sum + Number(t.amount), 0);

  const expense = transactions
    .filter((t) => t.type.toLowerCase() === "expense")
    .reduce((sum, t) => sum + Number(t.amount), 0);

  if (!transactions.length) {
    return <h3 style={{ textAlign: "center" }}>No Transactions Yet</h3>;
  }

  const pieData = [
    { type: "Income", value: income || 0 },
    { type: "Expense", value: expense || 0 },
  ];

  const lineData = transactions.map((t) => ({
    date: t.date,
    amount: Number(t.amount),
  }));

  const lineConfig = {
    data: lineData,
    xField: "date",
    yField: "amount",
    point: {
      size: 5,
      shape: "diamond",
    },
    smooth: true,
    height: 400,
  };

  const pieConfig = {
  data: pieData,
  angleField: "value",
  colorField: "type",
  radius: 0.8,
  height: 400,
  appendPadding: 20,
  label: {
    content: ({ type, value }) => `${type}: ₹${value}`,
  },
  legend: {
    position: "bottom",
  },
  interactions: [{ type: "element-active" }],
};

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "2fr 1fr",
        gap: "30px",
        marginTop: "40px",
        alignItems: "start",
      }}
    >
      <div>
        <h2>Financial Statistics</h2>
        <Line {...lineConfig} />
      </div>

      <div>
        <h2>Total Spending</h2>
        <Pie {...pieConfig} />
      </div>
    </div>
  );
}